import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateUtc',
  standalone: true
})
export class DateUtcPipe implements PipeTransform {
  transform(dateISO: string): string {
    if (!dateISO) return '';
    const date = new Date(dateISO);

    return `${date.getUTCFullYear()}-${(date.getUTCMonth())
      .toString()
      .padStart(2, '0')}-${date.getUTCDate().toString().padStart(2, '0')}T${date
      .getUTCHours()
      .toString()
      .padStart(2, '0')}:${date.getUTCMinutes().toString().padStart(2, '0')}Z`;
  }
}
  